
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"1em","height":"1em","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"16","cy":"17","r":"14","opacity":".2"}}),_c('circle',{attrs:{"cx":"16","cy":"16","r":"14","fill":"#138de7"}}),_c('path',{attrs:{"d":"M8 12v7.857A2.13 2.13 0 0010.125 22H20v-7.857C20 12.956 19.094 12 17.917 12h-7.792zm17 0l-4 2.5v5l4 2.5v-5z","opacity":".2"}}),_c('path',{attrs:{"d":"M8 11v7.857A2.13 2.13 0 0010.125 21H20v-7.857C20 11.956 19.094 11 17.917 11h-7.792zm17 0l-4 2.5v5l4 2.5v-5z","fill":"#fff"}}),_c('path',{attrs:{"d":"M16 2A14 14 0 002 16a14 14 0 00.021.586A14 14 0 0116 3a14 14 0 0113.979 13.414A14 14 0 0030 16 14 14 0 0016 2z","fill":"#fff","opacity":".2"}})])
          )
        }
      }
    